/**
 * Compute the overall status of a server from its current CPU/RAM/Disk metrics
 * and the configured thresholds.
 *
 *   "offline" — agent has not phoned home recently
 *   "crit"    — at least one metric is at or above its threshold
 *   "warn"    — at least one metric is within 15% of its threshold
 *   "ok"      — everything is comfortably under threshold
 */
export function statusOf(server, thresholds) {
  if (server.offline) return "offline";
  if (server.cpu == null && server.ram == null && server.disk == null) return "offline";
  const m = Math.max(
    (server.cpu ?? 0) / thresholds.cpu,
    (server.ram ?? 0) / thresholds.ram,
    (server.disk ?? 0) / thresholds.disk,
  );
  if (m >= 1) return "crit";
  if (m >= 0.85) return "warn";
  return "ok";
}

export function metricStatus(value, threshold) {
  if (value == null) return "offline";
  if (value >= threshold) return "crit";
  if (value >= threshold * 0.85) return "warn";
  return "ok";
}
